import React from 'react'
import PropTypes from 'prop-types'

import Text from './Text'

import styled, { css } from 'styled-components'
import { rem } from 'polished'

// Reopen the CookieYes banner so a visitor can grant consent for gated content.
export function openCookieSettings() {
  if (typeof document === 'undefined') return
  const revisit = document.querySelector(
    '.cky-btn-revisit-wrapper, .cky-btn-revisit, [data-cky-tag="revisit-consent"]',
  )
  if (revisit) revisit.click()
}

// Message + button shown in place of third-party content that is blocked until
// the visitor consents via CookieYes.
const ConsentNotice = ({ message }) => (
  <Inner>
    <Text center white size="xs" medium>
      {message}
    </Text>
    <ManageButton type="button" onClick={openCookieSettings}>
      Manage cookie settings
    </ManageButton>
  </Inner>
)

ConsentNotice.propTypes = {
  message: PropTypes.string,
}

ConsentNotice.defaultProps = {
  message: 'This content is hidden until you accept cookies.',
}

export default ConsentNotice

const Inner = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: ${theme.space(3)};
    text-align: center;
  `};
`

const ManageButton = styled.button`
  ${({ theme }) => css`
    margin-top: ${theme.space(2)};
    padding: ${theme.space(1)} ${theme.space(2)};
    border: 1px solid #fff;
    border-radius: ${theme.layout.borderRadius};
    color: #fff;
    background: transparent;
    font-size: ${rem(12)};
    cursor: pointer;
    transition: background 0.3s, color 0.3s;

    &:hover {
      background: #fff;
      color: ${theme.color.blue};
    }
  `};
`
